export default __webpack_public_path__ + "static/media/book-nav-icon3-completed.321f2e60.svg";